package org.moxultimate.topwithmox.di

import org.koin.core.context.startKoin
import org.koin.core.context.stopKoin
import org.koin.core.logger.Level
import org.koin.core.logger.Logger
import org.koin.core.logger.MESSAGE

/**
 * Starts the Koin DI container with all app modules.
 *
 * Call this once from [org.moxultimate.topwithmox.AppEntry] before the Compose
 * tree is built. Calling it more than once throws; use [stopKoin] in tests
 * to reset between runs.
 *
 * ```kotlin
 * @App
 * @Composable
 * fun AppEntry(content: @Composable () -> Unit) {
 *     remember { initKoin() }   // runs exactly once
 *     SilkApp { content() }
 * }
 * ```
 */
fun initKoin() {
    startKoin {
        logger(BrowserConsoleLogger())
        modules(appModule)
    }
}

/**
 * Koin logger that routes messages to the browser's developer console
 * instead of the JVM logger (which doesn't exist in Kotlin/JS).
 */
private class BrowserConsoleLogger : Logger() {
    override fun display(level: Level, msg: MESSAGE) {
        when (level) {
            Level.DEBUG -> console.log("[Koin] $msg")
            Level.INFO  -> console.info("[Koin] $msg")
            Level.WARNING -> console.warn("[Koin] $msg")
            Level.ERROR -> console.error("[Koin] $msg")
            Level.NONE  -> Unit
        }
    }
}
